export default "__VITE_ASSET__B__RJMlX__"